import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';
import { DataService } from 'src/app/Service/data.service';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { ClienteDireccion } from 'src/app/Models/cliente/clientedireccion/cliente-direccion';
@Component({
  selector: 'app-cliente-dialog',
  templateUrl: './cliente-dialog.component.html',
  styleUrls: ['./cliente-dialog.component.css']
})
export class ClienteDialogComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('txtdocumento', null) txtfirt: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
    @ViewChild(LoadingComponent, null) loading: LoadingComponent;
    @ViewChild(InfoComponent, null) info: InfoComponent;
    public isShow: boolean = false;
    public pagina: number = 0;
    public clientes: Cliente[] = [];
    public cliente: Cliente = new Cliente();
    public isEdit: boolean = false;
    public funcion: Function = null;
    public pagcli: any;
    public total:number=0;
    public adddescripcion: boolean = false;
    public search = '';
    public modal="modal-lg";
    public pagclidlg:any;
    public showdelete:boolean = false;
    public zindex:number = 10000;
    constructor(private data: DataService) { }
    public usuario = null;
    public tipodocumentos:TipoDocumento[] =[];
    public isdisabled:boolean= true;
    public clientedireccion:ClienteDireccion = new ClienteDireccion();
    public clientedirecciones:ClienteDireccion[] = [];
  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
      this.funcion = affterfunction;
      this.isShow = true;
      this.showTab(1);
      this.showdelete=false;
      setTimeout(() => {
          this.btnshow.nativeElement.click();
          this.info.hide();
          this.usuario = this.data.getCurrentUser();
          
      }, 10);
  }

  GetData() {
    this.loading.show("cargando..");
    this.clientes=[];
    if(this.search != undefined && this.search != ""){
        this.data.GetFromValue(this.data.api.cliente, 'like', this.search).subscribe(r => {
            console.log(r);
            this.loading.hide();
                if (this.data.Exists(r)) { this.clientes = r; this.total = this.clientes.length;}
        }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
    }else{
        this.data.GetSimple(this.data.api.cliente).subscribe(r => {
            console.log(r);
            this.loading.hide();
                if (this.data.Exists(r)) { this.clientes = r; this.total = this.clientes.length;}
        }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
    }
    
}
ShowInfoItem(i){
    this.cliente = this.clientes[i];
    this.showTab(3);
}
ShowNewItem() {
    this.isEdit = false;
    this.showTab(2);
    this.cliente = new Cliente();
    this.adddescripcion = false;
    this.getTipoDocumento();
    setTimeout(() => { this.txtfirt.nativeElement.focus(); }, 10);
}
ShowEditItem(i) {
    this.isEdit = true;
    this.getTipoDocumento();
    this.showTab(2);
    this.cliente = this.clientes[i];
    this.GetDireccion();
    // if(this.nacionalidad.descripcion != ""){this.adddescripcion = true;}else{this.adddescripcion = false;}
    setTimeout(() => { this.txtfirt.nativeElement.focus();  }, 10);
}
ShowDeleteItem(i){
    this.cliente = this.clientes[i];
    this.modal='';
    this.showdelete= true;
    this.info.show("¿Estimado usuario(a) deseas Quitar/Eliminar el elemento [nombre:\""+this.cliente.nombre+"\"] del sistema? ",1,null,{ cancelText: 'No, Cancelar', successText: 'Si, Continuar', isCancel: true },()=>{this.Delete();},()=>{this.showTab(1); this.modal='modal-lg'; this.showdelete=false; this.info.hide();},20);
}
async GetDireccion(){
    await this.data.selectP(this.data.api.clientedireccion,'cliente',this.cliente.idcliente).then(r=>{
        if(r[0].id != ''){
            this.clientedirecciones = r;
            console.log(r);
        }else{this.clientedirecciones = [];}
        
    }).catch(e=>{console.log(e.error)});
}
async DeleteItem(i){
    this.clientedireccion = this.clientedirecciones[i];
    if(this.clientedireccion.id == undefined){
        this.clientedirecciones.splice(i,1);
        this.countp--;
    }else{
        this.data.notify('Estimado(a), ¿Estas seguro de eliminar la dirección seleccionada?','Eliminar dirección',this.data.alertType.question,new ALertOption(true,true,'Sí, Eliminar','No, Cerrar'),async ()=>{
            
           await this.data.deleteP(this.data.api.clientedireccion,this.clientedireccion.id).then((r)=>{
               if(r.result > 0){
                 this.data.notify(r.message,'Registro Eliminado',this.data.alertType.success,new ALertOption());
               }else{
                this.data.notify(r.message,'Error al eliminar',this.data.alertType.error,new ALertOption());
               }
                this.GetDireccion();
            }).catch((e)=>{console.log(e.error)});
        });
    }
    
}
async SaveItem(){
    if (this.cliente.documento && this.cliente.nombre) {
        if(this.isEdit){//modificar
            this.loading.show('modificando datos');
            await this.data.updateP(this.data.api.cliente ,'all',this.cliente).then( async a=>{
                if(a.result == 1){
                    for (let clientedireccion of this.clientedirecciones) {
                        if(clientedireccion.id != undefined){
                            await this.data.updateP(this.data.api.clientedireccion,'all',clientedireccion).then(r=>{
                            }).catch(e=>{console.log(e.error);});
                        }else{
                            clientedireccion.cliente.idcliente = this.cliente.idcliente;
                            await this.data.insertP(this.data.api.clientedireccion,clientedireccion).then(async b =>{
                            }).catch(e=>{console.log(e)});
                        }
                        
                    }
                    this.GetDireccion();
                    if(this.funcion != undefined){this.funcion();}
                    this.data.notify('','Registro Guardado',this.data.alertType.success,new ALertOption(),()=>{
                        this.showTab(1);
                    });
                }else{
                    this.data.notify(a,'Error al guardar registro',this.data.alertType.error,new ALertOption());
                }
            }).catch(e=>{console.log(e);}) ;
            this.loading.hide();
    
        }else{//insert new
            this.loading.show('registrando Nuevo');
            await this.data.AsyncPost(this.data.api.cliente,this.cliente).then( async a=>{
               console.log(a);
                if(a.idcliente!=undefined){
                    this.data.notify('','Registro Guardado',this.data.alertType.success,new ALertOption(),()=>{this.showTab(1)});
                }else{
                    this.data.notify(a,'Error al registrar cliente',this.data.alertType.error,new ALertOption());
                }
            }).catch(e=>{console.log(e);}) ;
            this.loading.hide();
        }
    }else{
        this.data.notify("Llene los datos correctamente","Error",this.data.alertType.warning)
    }
}
SelectItem(i){
    this.cliente = i as Cliente;
    console.log(this.cliente);
    
    this.btnclose.nativeElement.click();
}

Delete(){
    this.loading.show('eliminando elemento');
    this.data.delete(this.data.api.cliente,this.cliente.idcliente).subscribe(r=>{
        this.loading.hide();
        this.info.show(r.message,r.result,null,null,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});
        if(r.result == 1) { this.GetData();}
    },e=>{this.info.error(e,()=>{this.info.hide(); this.modal='modal-lg'; this.showdelete=false;});})
}

  showTab(i) {

    this.pagina = i;
    if(this.pagina == 1){this.modal ='modal-lg';}
    else{this.modal='';}
}

  close() {
      this.btnclose.nativeElement.click();
      setTimeout(() => { this.isShow=false; }, 1000);
      setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
  }
  public disabled_form():string{ return (this.isdisabled? 'true':'false'); }

  public async searchSunat(){
    this.data.wait('Espere por favor, estamos buscando el número de documento en SUNAT','Buscando Número');
    await this.data.Consulta('ruc',this.cliente.documento).then(r=>{
        console.log(r);
        this.data.notifyClose();
        try{
            if(r.result > 0){
                this.cliente.nombre = r.message.razon_social;
                this.cliente.direccion = r.message.domicilio_fiscal;
                
                this.isdisabled= false;

            }else{
                this.isdisabled =true;
                
               
                
                this.data.notify('Estimado(a), Número de documento no encontrado en los registros de la SUNAT. ¿Desea continuar con el registro del cliente?','RUC no encontrado',this.data.alertType.error,new ALertOption(true,false,'Sí Continuar','No, Cerrar'),()=>{
                    this.isdisabled = false;

                    
                },()=>{
                    this.isdisabled = true;

                    this.cliente.documento = null;
                });
            }
        }catch(ex){console.log(ex);}
        console.log(r);
    });
}

    public countp:number=0;
    generaDireccion(){
        let pr:ClienteDireccion[]=[];
        this.countp=0;
        if(this.clientedirecciones.length > 0){
            for (let item of this.clientedirecciones) {
                item.direccion = item.direccion != undefined ? item.direccion : null;
                item.n = this.countp.toString();
            // item.igv = '18';
                this.countp++;
                pr.push(item);
            }
        }
        let p:ClienteDireccion = new ClienteDireccion();
        p.n = this.countp.toString();
        p.direccion = null;
        pr.push(p);
        
        this.clientedirecciones = pr;
    }
  public async getTipoDocumento(){
    //this.wait.tipodocumento = true;
    await this.data.AsyncGetSimple(this.data.api.tipodocumento).then(r =>{
        //this.wait.tipodocumento = false;
        try {
            this.tipodocumentos = r;
        } catch (ex) { console.log(ex); }
    });
}

}
